import { Box, Typography } from "@mui/material";
import { AUTH_TEXT_PRIMARY, AUTH_TEXT_SECONDARY, BRAND_BLUE, BRAND_BLUE_DARK, BRAND_BLUE_LIGHT } from "../theme/appTheme";
import { useTranslation } from "../i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";

// App-wide "everything is down" screen. Rendered by App.js in place of the
// entire router tree whenever maintenance mode is active - no route,
// provider, or API call ever mounts underneath it. Plain full-height block
// (not position:fixed) since this is the only thing on screen in that state -
// matches AuthBlankScreen's convention and avoids fighting the LanguageSwitcher
// menu's own portal z-index.
function MaintenancePage() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        background: `linear-gradient(155deg, ${BRAND_BLUE_DARK} 0%, ${BRAND_BLUE} 55%, ${BRAND_BLUE_LIGHT} 120%)`,
      }}
    >
      <LanguageSwitcher />
      <Box
        sx={{
          bgcolor: "#ffffff",
          borderRadius: 3,
          p: { xs: 4, sm: 6 },
          maxWidth: 460,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
      >
        <img
          src="/Sibolab_Logo_darkblue_rgb.png"
          alt="Sibolab"
          style={{ height: "44px", width: "auto", objectFit: "contain", marginBottom: 24 }}
        />
        <Typography sx={{ fontWeight: 700, fontSize: "1.375rem", color: AUTH_TEXT_PRIMARY, mb: 1.5 }}>
          {t("maintenance.title")}
        </Typography>
        <Typography sx={{ color: AUTH_TEXT_SECONDARY, fontSize: "0.9375rem", lineHeight: 1.6 }}>
          {t("maintenance.body")}
        </Typography>
      </Box>
    </Box>
  );
}

export default MaintenancePage;
